import type { NPCConfig } from '@/entities';
// import {StoryManager} from "@/systems";

//Bakal ditaro di semua, sebelum diana mati (Day 2 Part X)
const config: NPCConfig[] = [
  {
    x: 1900,
    y: 1470,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'rumah_1',
      nodes: {
        rumah_1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Rumah ini adalah rumah masa kecilku.',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "rumah_2"
        },
        rumah_2: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Dulu, aku nenek dan Diana tinggal disini',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "rumah_3",
        },
        rumah_3: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Sampai aku ke kota untuk belajar 4 tahun lalu.',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "rumah_2",
          isEnd : true,
        },
      },
    },
  },
  {
    x: 1800,
    y: 1810,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'rumah_1',
      nodes: {
        rumah_1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Ini adalah rumah Bunga, tetanggaku dari masa kecil',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "rumah_2"
        },
        rumah_2: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Dulu hampir setiap hari aku kesini untuk menjemput Bunga untuk bermain.',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "rumah_3",
          isEnd :true
        },
      },
    },
  },
  {
    x: 2120,
    y: 1890,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'rumah_1',
      nodes: {
        rumah_1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Ini adalah rumah Ato',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "rumah_2"
        },
        rumah_2: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Rumahnya sangat tidak terurus, dan berbau alkohol',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "rumah_3",
          isEnd :true
        },
      },
    },
  },
  {
    x: 2400,
    y: 1720,
    name: '',
    color: 0x9932cc,
    repeatable : true,
    flipSprite : false,
    spriteImage: 'assets/sprite/nada.png',
    dialogTree: {
      startDialogId: 'rumah_1',
      nodes: {
        rumah_1: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Dulu, rumah ini milik Kak Yanti',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "rumah_2"
        },
        rumah_2: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Tetapi, sekarang sepertinya sudah ditinggali oleh orang lain.',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "rumah_3",
        },
        rumah_3: {
          id: 'toilet_1',
          speaker: 'Yan',
          text: 'Apakah Kak Yanti pindah ke kota?',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: '/assets/backdrop/desa.ktx2',
          nextDialogId : "rumah_3",
          isEnd :true
        },
      },
    },
  },
  {
    x: 3200,
    y: 1050,
    name: 'Penjual',
    color: 0x9932cc, // Dark orchid
    repeatable : true,
    spriteImage: 'assets/sprite/sprite_npc_mom.png', // Use NPC image
    dialogTree: {
      startDialogId: 'penjual_part1_1',
      nodes: {
        penjual_part1_1: {
          id: 'penjual_part1_1',
          speaker: 'Penjual',
          text: `Cap tikus kami terbaik, seharga 200 rupiah saja! Ada yang bisa saya bantu?`,
          characterImage: '/assets/character/mom.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId: 'penjual_part1_2',
        },
        penjual_part1_2: {
          text : "",
          id: 'penjual_part1_1',
          speaker: 'Penjual',
          characterImage: '/assets/character/mom.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          choices: [
            {
              text: 'Saya hanya ingin melihat-lihat',
              nextDialogId: 'penjual_part1_3',
            },
            {
              text: 'Saya ingin membeli kado untuk gadis kecil. Apakah ada?',
              nextDialogId: 'penjual_part1_3a',
            },
            {
              text: 'Saya ingin membeli cap tikus',
              nextDialogId: 'penjual_part1_a1',
              requirements: {
                requiredItems: [{ itemId: 'coin_gold', quantity: 200 }],
              },
              consumeItems: [
                { itemId: 'coin_gold', quantity: 200 }
              ],
              itemReward: { itemId: 'cap_tikus', quantity: 1},
            },
          ],
        },
        penjual_part1_a1: {
          id: 'kuburan4',
          speaker: 'Yan',
          text: `Yan memberikan 200 rupiah dan mendapatkan cap tikus!`,
          isEnd : true,
        },
        penjual_part1_3a: {
          id: 'penjual_part1_3',
          speaker: 'Penjual',
          text: `Kami tidak menjual barang seperti itu. Mungkin bisa mencari di toko lain.`,
          characterImage: '/assets/character/mom.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId: 'penjual_part1_3',
          isEnd: true
        },
        penjual_part1_3: {
          id: 'penjual_part1_3',
          speaker: 'Penjual',
          text: `Terima kasih, sampai jumpa!`,
          characterImage: '/assets/character/mom.png',
          backgroundImage: '/assets/backdrop/rumah.ktx2',
          nextDialogId: 'penjual_part1_2',
          isEnd: true
        },
      },
    },
  },
  {
    x: 3510,
    y: 1720,
    name: 'Informasi',
    spriteImage: 'assets/sprite/nada.png', // Use NPC image
    dialogTree: {
      startDialogId: 'informasi1',
      nodes: {
        informasi1: {
          id: 'informasi1',
          speaker: '',
          text: `Anda memasuki daerah cagar alam Danau Bacoputi`,
          nextDialogId : "kuburan2",
          isEnd : true
        },
      },
    },
  },
  {
    x: 4390,
    y: 2000,
    name: '',
    scale : 1.25,
    hideOnState : ["ROD_USED"],
    spriteImage: 'assets/sprite/sprite_pancingan.png', // Use NPC image
    repeatable : false,
    interactOnce : true,
    dialogTree: {
      startDialogId: 'fishing_1',
      nodes: {
        fishing_1: {
          id: 'fishing_1',
          speaker: 'Yan',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: 'assets/backdrop/danau.ktx2',
          text: `Ada Umpan dan Pancingan`,
          nextDialogId : "fishing_2",
        },
        fishing_2: {
          id: 'fishing_2',
          speaker: 'Yan',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Seberapa jauh harus melempar umpan?`,
          backgroundImage: 'assets/backdrop/danau.ktx2',
          nextDialogId : "fishing_3",
        },
        fishing_3: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          text: ``,
          backgroundImage: 'assets/backdrop/danau.ktx2',
          choices: [
            {
              text: '[Lempar umpan jarak dekat]',
              nextDialogId: 'fishing_a1',
              itemReward: { itemId: 'fish', quantity: 1},
            },
            {
              text: '[Lempar umpan jarak sedang]',
              nextDialogId: 'fishing_b1',
              itemReward: { itemId: 'liontin', quantity: 1},
            },
            {
              text: '[Lempar umpan jarak jauh]',
              nextDialogId: 'fishing_c1',
              itemReward: { itemId: 'sendal', quantity: 1},
            },
          ],
        },
        fishing_ending: {
          id: 'fishing_2',
          speaker: 'Yan',
          backgroundImage: 'assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Pancingan sudah tidak bisa dipakai`,
          isEnd : true,
        },

        fishing_a1: {
          id: 'fishing_2',
          speaker: '',
          backgroundImage: 'assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/yanf.png',
          text: `...`,
          nextDialogId : "fishing_a2",
          sfx : "fishingReel"
        },
        fishing_a2: {
          id: 'fishing_2',
          speaker: '',
          backgroundImage: 'assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/yanf.png',
          text: `...`,
          nextDialogId : "fishing_a3",
          sfx : "fishingReel"
        },
        fishing_a3: {
          id: 'fishing_2',
          speaker: '',
          backgroundImage: 'assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Yan Mendapatkan Ikan!`,
          nextDialogId : "fishing_ending",
        },

        fishing_b1: {
          id: 'fishing_2',
          speaker: '',
          backgroundImage: 'assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/yanf.png',
          text: `...`,
          nextDialogId : "fishing_b2",
          sfx : "fishingReel"
        },
        fishing_b2: {
          id: 'fishing_2',
          speaker: '',
          backgroundImage: 'assets/backdrop/danau.ktx2',
          characterImage: '/assets/character/v2/yanf.png',
          text: `...`,
          nextDialogId : "fishing_b3",
          sfx : "fishingReel"
        },
        fishing_b3: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Yan Mendapatkan Liontin!`,
          backgroundImage: 'assets/backdrop/danau.ktx2',
          nextDialogId : "fishing_b4a",
        },
        fishing_b4a: {
          id: 'fishing_2',
          speaker: 'Yan',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: 'assets/backdrop/danau.ktx2',
          text: `Liontin ini, aku merasa pernah melihat liontin ini sebelumnya`,
          nextDialogId : "fishing_b4",
        },
        fishing_b4: {
          id: 'fishing_2',
          speaker: 'Yan',
          characterImage: '/assets/character/v2/yanf.png',
          text: `Liontin ini bisa menjadi kado untuk Diana.`,
          backgroundImage: 'assets/backdrop/danau.ktx2',
          nextDialogId : "fishing_ending",
        },
        fishing_c1: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: 'assets/backdrop/danau.ktx2',
          text: `...`,
          nextDialogId : "fishing_c2",
          sfx : "fishingReel"
        },
        fishing_c2: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: 'assets/backdrop/danau.ktx2',
          text: `...`,
          nextDialogId : "fishing_c3",
          sfx : "fishingReel"
        },
        fishing_c3: {
          id: 'fishing_2',
          speaker: '',
          characterImage: '/assets/character/v2/yanf.png',
          backgroundImage: 'assets/backdrop/danau.ktx2',
          text: `Yan Mendapatkan Sendal!`,
          nextDialogId : "fishing_ending",
          storyAction: { type: 'addState', value: "ROD_USED" },
        },
      },
    },
  },
];

export default config;
